import is from '@sindresorhus/is';
import { createContext, useContext } from 'react';
import type { StoreApi } from 'zustand';
import { useStore } from 'zustand';

import type { CommentsGroupStore } from './comments-group-store';

export const CommentsGroupStoreContext = createContext<StoreApi<CommentsGroupStore> | null>(null);

export const useOptionalCommentsGroupStoreApi = (): StoreApi<CommentsGroupStore> | null =>
    useContext(CommentsGroupStoreContext);

export const useCommentsGroupStoreApi = (): StoreApi<CommentsGroupStore> => {
    const store = useContext(CommentsGroupStoreContext);
    if (is.null(store)) {
        throw new Error('useCommentsGroupStoreApi must be used inside <CommentsGroupSurfaceProvider>');
    }
    return store;
};

export const useCommentsGroupStore = <T>(selector: (state: CommentsGroupStore) => T): T =>
    useStore(useCommentsGroupStoreApi(), selector);
